<template>
  <div class="bg-gradient h-100 d-flex align-center">
    <v-container class="custom-container">
      <v-row no-gutters>
        <v-col
          cols="12"
          md="5"
          offset-lg="2"
          lg="3"
          offset-xl="1"
          xl="4">
          <div class="bg-img custom-shadow d-none d-md-block"></div>
        </v-col>
        <v-col
          cols="12"
          md="7"
          lg="5"
          xl="6">
          <slot name="main" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.main-login {
  min-height: 90vh;
  padding: 40px 30px;
}
.wrap-form {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.bg-img {
  display: block;
  background-position: bottom center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-image: url('~@/assets/img/bg/img_login_register.png');
}
.bg-gradient {
  background: linear-gradient(128.76deg, #baf2ff 4%, #fff1e1 102.85%);
}
.custom-shadow {
  box-shadow: 0px 10px 14px rgba(173, 173, 173, 0.25);
}
.center-divider {
  .divider {
    top: 50%;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    height: 1px;
    background-color: #e4e4e4;
    z-index: 2;
  }
  span {
    z-index: 3;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .main-login {
    height: 95vh;
  }
}
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .main-login {
    height: auto !important;
    padding: 20px 50px;
  }
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .main-login {
    height: auto !important;
    padding: 34px 110px 15px;
    min-height: 96vh;
  }
}
@media #{map-get($display-breakpoints, 'lg-only')} {
  .logo-home {
    max-width: 160px;
    max-height: 30px;
  }
}
@media #{map-get($display-breakpoints, 'xl-only')} {
  .main-login {
    height: auto !important;
    padding: 70px 150px 35px;
  }
}

// mobile landscape
@media screen and (orientation:landscape)
and (min-device-width: 319px)
and (max-device-width: 900px) {
  .main-login {
    min-height: auto;
    height: auto;
  }
}
</style>
